"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrderProductToProduct = void 0;
const mapOrderProductToProduct = (orderProduct) => {
    return {
        id: orderProduct.productId,
        url: orderProduct.url,
        originalPrice: orderProduct.originalPrice,
        scoringFactor: orderProduct.scoringFactor,
        discountBadgeId: orderProduct.discountBadgeId,
        discountBadgeName: orderProduct.discountBadgeName,
        price: orderProduct.price,
        trackingName: orderProduct.trackingName,
        trackingPath: orderProduct.trackingPath,
        title: orderProduct.title,
        productType: orderProduct.productType,
        manufacturerSku: orderProduct.manufacturerSku,
        hasFriendsDiscount: orderProduct.hasFriendsDiscount,
        nudge: orderProduct.nudge,
    };
};
exports.mapOrderProductToProduct = mapOrderProductToProduct;
//# sourceMappingURL=mapOrderProductToProduct.js.map